// src/context/SidebarForgeContext.jsx
// ─────────────────────────────────────────────────────────────────────────────
// BoneForge modülünün sidebar açık/kapalı durumunu yönetir.
// SidebarMinigameContext ile aynı pattern — tamamen bağımsız.
// ─────────────────────────────────────────────────────────────────────────────
import React, { createContext, useContext, useState, useCallback } from "react";

const SidebarForgeContext = createContext(null);

export function SidebarForgeProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  const openSidebar   = useCallback(() => setIsOpen(true),    []);
  const closeSidebar  = useCallback(() => setIsOpen(false),   []);
  const toggleSidebar = useCallback(() => setIsOpen(s => !s), []);

  return (
    <SidebarForgeContext.Provider value={{ isOpen, openSidebar, closeSidebar, toggleSidebar }}>
      {children}
    </SidebarForgeContext.Provider>
  );
}

export function useSidebarForge() {
  const ctx = useContext(SidebarForgeContext);
  if (!ctx) throw new Error("useSidebarForge must be used within SidebarForgeProvider");
  return ctx;
}
